module.exports = __webpack_public_path__ + "static/media/traffic-cone.260eb823.svg";